import styles from './Spinner.module.css';

/**
 * Loading spinner. `inline` drops the centring margin so it can sit inside a
 * button next to the label.
 */
export function Spinner({ size = 34, inline = false, label = 'Loading' }) {
  return (
    <span
      className={`${styles.spinner} ${inline ? styles.inline : ''}`}
      style={{ '--spinner-size': `${size}px` }}
      role="status"
      aria-label={label}
    />
  );
}
